import { render, staticRenderFns } from "./StatePill.vue?vue&type=template&id=5908cd2c&scoped=true&"
import script from "./StatePill.vue?vue&type=script&lang=js&"
export * from "./StatePill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908cd2c",
  null
  
)

export default component.exports